<template>
    <tr v-if="permission_group">
        <td> {{ permission_group.name }}</td>
        <td>
            <router-link :to="{name: 'edit_permission_group', params: {identity: permission_group.identity}}" class="ui basic green button">
                {{ $t('ui.general.edit') }}
            </router-link>
        </td>
        <td>
            <a href="#" @click.prevent="delete_permission_group()" class="ui basic red button">{{ $t('ui.general.delete') }}</a>
        </td>
    </tr>
</template>

<script>
export default {
    name: "ProviderPermissionGroupsIndexTableItem",
    props: {
        permission_group: Object
    },
    computed: {
    },
    methods: {
        delete_permission_group: function() {
            var that = this;

            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_permission_group_delete).parse({
                    "identity": that.permission_group.identity,
                });

                axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(function (response) {
                        if (response.data.status == "success") {
                            that.$el.remove();
                            // that.$noty.success('刪除' + that.permission_group.name + '成功');
                            that.$noty.success(
                                that.$t('ui.notifications.success.delete__name', {
                                    name: that.permission_group.name
                                })
                            );
                        } else {
                            // that.$noty.error('無法刪除permission_group');
                            that.$noty.error(
                                that.$t('ui.notifications.error.delete__name', {
                                    name: that.permission_group.name,
                                })
                            );
                        }
                    })
                    .catch(function (error) {
                        // that.$noty.error('刪除permission_group失敗');
                        that.$noty.error(
                            that.$t('ui.notifications.error.delete__name', {
                                name: that.permission_group.name,
                                reason: ': ' + error
                            })
                        );
                    });

            }
        },
    },

}
</script>

<style scoped>
</style>
